import { useEffect } from "react";

const ExternalPageOpener: React.FC = () => {

    useEffect(() => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const targetUrl = params.get('url');
        if (targetUrl) {
            window.location.replace(`${process.env.REACT_APP_CLASSIC_URL}${targetUrl}`);
        }
    }, []);
    return <></>;
};

export default ExternalPageOpener;